import { render, staticRenderFns } from "./receive-dialog.vue?vue&type=template&id=ad25c892&scoped=true&"
import script from "./receive-dialog.vue?vue&type=script&lang=js&"
export * from "./receive-dialog.vue?vue&type=script&lang=js&"
import style0 from "./receive-dialog.vue?vue&type=style&index=0&id=ad25c892&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad25c892",
  null
  
)

export default component.exports